import moment from "moment";

// HELPERS
import api from "@helpers/api";

const useCrmEvent = props => {
  const { event, past, updateEvents } = props;

  const needsAction = past
    ? moment(event.EndTime).isBefore(moment()) && event.Attended === "unknown"
    : false;

  const handleAttendance = async (event, attended) => {
    try {
      const response = await api("/client/events/attend", {
        eventId: event.EventId,
        attended
      });

      const updatedEvent = {
        ...event,
        Attended: attended
      };

      updateEvents(updatedEvent);
    } catch (error) {
      console.error("Error updating attendance:", error);
    }
  };
  
  return {
    event,
    past,
    needsAction,
    handleAttendance
  };
};

export default useCrmEvent;